import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DocketDetailsDS from "../../DataServices/DocketDetailsDS";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import { insertLog } from '../Logs/InsertLog';

export const useDocketDetailsLogic = () => {
    const navigate = useNavigate();
    const docketDS = new DocketDetailsDS();
    const [showModal, setShowModal] = useState(false);
    const [dockets, setDockets] = useState([]);
    const [search, setSearch] = useState('');
    const [selectedDocket, setSelectedDocket] = useState(null);
    const { hud, stopHudRotation, showAlert } = useCustomContext();
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];

    const filteredDockets = dockets.filter(d =>
        d.dataset_id?.toLowerCase().includes(search.toLowerCase())
    );

    useEffect(() => {
        fetchDockets();
    }, []);

    const fetchDockets = async () => {

        hud("Please wait...");
        try {
            const response = await docketDS.WS_Data_Scrapper_Docker_Details_GET({});
            const data = response.data;

            const body = typeof data.body === "string"
                ? JSON.parse(data.body)
                : data.body;

            if (data.statusCode === 200 && Array.isArray(body.data)) {
                setDockets(body.data);
            } else {
                insertLog(
                    `${userName} failed to load dockets`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'GET',
                    'WS_Data_Scrapper_Docker_Details_GET',
                    'FAILED',
                    'Unable to load dockets'
                );
                showAlert("Failed to load dockets", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch dockets`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'WS_Data_Scrapper_Docker_Details_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Error fetching dockets", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
        } finally {
            stopHudRotation();
        }

    };


    const handleEdit = async (item) => {
        hud("Please wait...");
        try {
            const res = await docketDS.WS_Data_Scrapper_Docker_Details_GET_BY_ID({ _id: item._id });
            console.log("Sending payload:", { _id: item._id })
            const data = res.data;
            const body = typeof data.body === "string"
                ? JSON.parse(data.body)
                : data.body;

            if (data.statusCode === 200 && body?.data) {
                setSelectedDocket(body.data);  // 🔥 fresh data
                setShowModal(true);
            } else {
                insertLog(
                    `${userName} failed to fetch docket details for id ${item._id}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    item._id || '',
                    'GET',
                    'WS_Data_Scrapper_Docker_Details_GET_BY_ID',
                    'FAILED',
                    'Unable to fetch docket details'
                );
                showAlert("Failed to fetch docket details", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch docket details for id ${item._id}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                item._id || '',
                'GET',
                'WS_Data_Scrapper_Docker_Details_GET_BY_ID',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Error fetching details", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
        } finally {
            stopHudRotation();
        }
    };
    return {
        displayedDockets: filteredDockets,
        search,
        setSearch,
        showModal,
        setShowModal,
        handleEdit,
        selectedDocket,
        setSelectedDocket,
        fetchDockets,
        dockets
    };
};